export default "__VITE_ASSET__D$lf7kQ4__"